import { FirebaseApp, initializeApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';
import { Firestore, getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyB7U25dMjJxByPEZxSYiyOpgzr6JQ3QYWk',
  authDomain: 'flatten-53b39.firebaseapp.com',
  projectId: 'flatten-53b39',
  storageBucket: 'flatten-53b39.firebasestorage.app',
  messagingSenderId: '498537143378',
  appId: '1:498537143378:web:f94d4e536450327612d38b',
};

const app: FirebaseApp = initializeApp(firebaseConfig);
const database: Firestore = getFirestore(app);
let auth: Auth = getAuth();

export { app, auth, database };
